import { LoaderActions } from '@store/loaders'
import { logout as legacyLogout } from '@storeOld/reducers/auth'
import { call, put } from 'redux-saga/effects'

import { pushPlanTier } from '@/constants/gtm'
import { NestClient } from '@/nest'
import { reloadToOrigin } from '@/utils/reloadToOrigin'

export function* logout() {
  // Глобальный лоадер до самой перезагрузки: прячет страницу на время
  // запроса и не даёт AuthenticatedWrapper показать GuestGate с модалкой
  // логина, когда стор уже анонимный. Гасить не нужно — страница умирает.
  yield put(LoaderActions.set('authentication'))

  yield call(NestClient.auth.logout)

  yield put(legacyLogout())
  pushPlanTier(null)

  yield call(reloadToOrigin)
}
